import React, { useState, useEffect } from "react";
import RangeSelector, { Size, Scale, SliderMarker, MinorTick } from 'devextreme-react/range-selector';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Tooltip, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import TimeRange from 'react-timeline-range-slider'
function TimeRangeChart(props) {
    const { t } = useTranslation();
    const [key, setKey] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setKey(prevKey => prevKey + 1);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const updateVisualRange = (e) => {
        //Update date range values (This will select and deselect all measurements between these dates)
        // if (JSON.stringify(objNewTimeRangeDate) !== JSON.stringify(props.timeRangeDates)) {
        props.updateDataRange(e.value, false);

        // } 
    }
    const handlePreviousDay = () => {
        var dupDateRange = JSON.parse(JSON.stringify(props.timeRangeDates));
        var dupFromDate = new Date(dupDateRange.fromDate);
        var tempToDate = new Date(dupDateRange.fromDate);

        var tempFromDate = new Date(dupFromDate.getTime() - 86401000);
        props.updateDataRange([tempFromDate, tempToDate], true);


    }
    const handleNextDay = () => {
        var dupDateRange = JSON.parse(JSON.stringify(props.timeRangeDates));
        var dupToDate = new Date(dupDateRange.toDate);
        var tempFromDate = new Date(dupDateRange.toDate);
        var tempToDate = new Date(dupToDate.getTime() + 86401000);
        props.updateDataRange([tempFromDate, tempToDate], true);

    }
    const dateFormatter = (date) => {
        const hour = date.getHours();
        const minute = date.getMinutes();
        return `${("0" + (date.getDate())).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()} ${("0" + (hour)).slice(-2)}:${("0" + (minute)).slice(-2)}`;


        //let tempTomorrow = new Date(date.getDate() + 86400000);
    }

    return (

        <React.Fragment>
            {props.timeRangeDates !== null &&
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                        <Tooltip title={t('timeRangeChart.previous24Hours')} arrow>
                            <IconButton style={{ backgroundColor: "var(--color-primary)", color: "white" }} sx={{ boxShadow: 3 }} onClick={handlePreviousDay} size={"small"}>
                                <ChevronLeft fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div style={{ width: '100%' }}>
                        <RangeSelector key={key} id="range-selector" selectedRangeColor="var(--color-primary)" onValueChanged={(e) => updateVisualRange(e)} value={[props.timeRangeDates.fromDate, props.timeRangeDates.toDate]}>
                            <Scale startValue={props.timeRangeDates.startDate} endValue={props.timeRangeDates.endDate} tickInterval={"hours"} >
                                <MinorTick visible={false} />
                            </Scale>
                            <SliderMarker format={dateFormatter} />
                            <Size height={50} />
                        </RangeSelector>
                    </div>
                    <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                        <Tooltip title={t('timeRangeChart.next24Hours')} arrow>
                            <IconButton style={{ backgroundColor: "var(--color-primary)", color: "white" }} sx={{ boxShadow: 3 }} onClick={handleNextDay} size={"small"}>
                                <ChevronRight fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            }
        </React.Fragment>
    )
} export default TimeRangeChart;
